@let cameraState = status();

<app-pan-chip [width]="150" fill="outline" [color]="cameraState === 'unhealthy' ? 'danger' : 'success'">
  <div class="flex items-center w-full gap-2">
    <app-pan-video-status [status]="status()"></app-pan-video-status>

    {{ cameraState === "unhealthy" ? "Disconnected" : "Active" }}
  </div>
</app-pan-chip>
